const { invokeRestServiceWithParameters } = require("@js/common/util/web-service/gisServerServices.ts");
const {
    RELOAD_CHANGES,
    setChangesGeneratedDateAction,
    hideChangesLoaderAction,
} = require("@js/changes/action/reloadChangesAction");
const { doNothingAction } = require("@js/common/action/doNothingAction");
const moment = require("moment");
const Logger = require("@js/common/util/Logger");
const { MAP_CONFIG_LOADED } = require("@mapstore/actions/config");

const logger = new Logger("reloadChangesEpic");

const reloadChangesEpic = (action$, store) =>
    action$.ofType(RELOAD_CHANGES, MAP_CONFIG_LOADED).switchMap((action) => {
        const state = store.getState();

        if (!state.urlParams.slots.haveSlotIds()) {
            return [doNothingAction(), hideChangesLoaderAction()];
        }

        const restOptions = {
            slotIds: state.urlParams.slots.getSlotIds(),
            forceReload: action.type === RELOAD_CHANGES,
        };

        return invokeRestServiceWithParameters(state, "sdo/loadSlotChanges", restOptions)
            .map((response) => {
                return response.data
                    ? setChangesGeneratedDateAction(moment(response.data).utc().format("YYYY-MM-DD HH:mm:ss"))
                    : doNothingAction();
            })
            .catch((e) => {
                logger.error("Error reloading changes on GIS Server.", e);
                return [doNothingAction()];
            });
    });

module.exports = reloadChangesEpic;
